import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { errorLoginUser } from "../../actions/snackbarActions";
import { Endpoint, Status } from "../../apis/apiConstants";
import AjaxHelper from "../../apis/apiRequest";
import { APPROVAL } from "../../common/constants";
import LoadingAnimation from "../../components/LoadingAnimation";
import MPasswordField from "../../components/MPasswordField";
import MTextField from "../../components/MTextField";
import AppFooter from "../../components/appFooter";
import { PATH, SnackbarType } from "../../constants/appConstants";
import { isFieldEmpty } from "../../helpers/appFieldValidation";
import SessionDetails from "../../helpers/sessionDetails";
import { getCopy, openInNewTab } from "../../helpers/utils.helper";
import { setResponsiveDialog } from "../../reducers/responsiveDialogReducer";
import { setSnackbar } from "../../reducers/snackbarReducer";
import "./login.scss";

const companyLogo = require("../../assets/logo.png");
const sponsors = [
  {
    imageUrl: "https://www.adilqadri.com",
    imagePath: require("../../assets/img/sponsors/adilqadri.jpg"),
    isCircular: true,
  },
  {
    imageUrl: "https://wa.me/919825006786",
    imagePath: require("../../assets/img/sponsors/al_noor.jpg"),
    isCircular: true,
  },
  {
    imageUrl: "http://www.nationalseafood.in/iis6954.asp",
    imagePath: require("../../assets/img/sponsors/national.jpg"),
    isCircular: true,
  },
  {
    imageUrl: "https://www.facebook.com/cbcbelt",
    imagePath: require("../../assets/img/sponsors/choice.jpg"),
    isCircular: true,
  },
  {
    imageUrl: "https://www.facebook.com/kctkhatri",
    imagePath: require("../../assets/img/sponsors/khatri.jpg"),
    isCircular: true,
  },
  {
    imageUrl: "https://www.alasiya.tours/",
    imagePath: require("../../assets/img/responsors/asiya.jpg"),
    isCircular: true,
  },
  {
    imageUrl: "https://www.anasrealty.com/",
    imagePath: require("../../assets/img/sponsors/anas.jpg"),
    isCircular: true,
  },
  {
    imageUrl: "https://www.memonac.com/",
    imagePath: require("../../assets/img/responsors/accounting.jpg"),
    isCircular: true,
  },
  {
    imageUrl: "https://wa.me/918575276666",
    imagePath: require("../../assets/img/sponsors/villazio.jpg"),
    isCircular: true,
  },
  {
    imageUrl: "https://bakhlatravels.com/",
    imagePath: require("../../assets/img/sponsors/bakhlatravels.jpg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
  {
    imageUrl: "",
    imagePath: require("../../assets/img/sponsors/contact.jpeg"),
    isCircular: true,
  },
];

export default function Login(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [errors, setErrors] = useState([]);
  const [user, setUser] = useState({
    email: "",
    password: "",
    errorEmail: "",
    errorPassword: "",
    showPassword: false,
  });
  const [loadingApi, setLoadingApi] = useState(false);

  useEffect(() => {
    if (SessionDetails.isUserLoggedIn()) {
      navigate(PATH.DASHBOARD_SCREEN);
    }
    console.log(sponsors);
  }, [props]);

  const getValidation = () => {
    const validations = [];
    if (isFieldEmpty(user.userCode)) {
      validations.push({
        name: "userCode",
        validation: "Memon ID is mandatory.",
      });
    }

    if (isFieldEmpty(user.password)) {
      validations.push({
        name: "password",
        validation: "Password is mandatory.",
      });
    }
    setErrors(validations);
    return validations.length === 0;
  };

  const onSubmit = () => {
    if (getValidation()) {
      setLoadingApi(true);
      AjaxHelper.postApi(navigate, Endpoint.LOGIN, {
        userCode: user.userCode,
        password: user.password,
      })
        .then((response) => {
          console.log("RES: ", response.data);
          setLoadingApi(false);

          if (response.data.status === Status.API_SUCCESS) {
            const currentUser = response.data.data;

            if (currentUser.reqStatus === APPROVAL.ACCEPT) {
              SessionDetails.saveAccessToken(currentUser.accessToken);
              SessionDetails.saveRefreshToken(currentUser.refreshToken);
              SessionDetails.saveCurrentUser(currentUser);
              navigate(PATH.DASHBOARD_SCREEN);
            } else {
              if (
                currentUser.isEmailVerified === 0 &&
                currentUser.isMobileNoVerified === 0
              ) {
                navigate(PATH.VERIFY_EMAIL, {
                  replace: true,
                  state: { email: currentUser.email, userCode: user.userCode },
                });
              } else if (currentUser.reqStatus === APPROVAL.PENDING) {
                dispatch(
                  setResponsiveDialog(
                    true,
                    "Account verification in process",
                    `Your application is with Jamat admin. It will take some time for the admin to accept your application. You will receive email on ${currentUser.email}.`,
                    "OK"
                  )
                );
              } else {
                dispatch(
                  setResponsiveDialog(
                    true,
                    "Application rejected",
                    `Your application is rejected by Jamat admin. Please contact your jamat admin for further process.`,
                    "OK"
                  )
                );
              }
            }
          } else {
            dispatch(
              setSnackbar(
                true,
                SnackbarType.ERROR,
                "Please enter valid Memon ID and password to login."
              )
            );
          }
        })
        .catch((err) => {
          setLoadingApi(false);
          dispatch(errorLoginUser);
        });
    } else {
      dispatch(
        setResponsiveDialog(
          true,
          "Error",
          "Please enter valid Memon ID and password to login.",
          "OK"
        )
      );
    }
  };

  const getFieldErrorText = (key) => {
    const vField = errors.filter((v) => v.name === key);
    if (vField.length > 0) {
      return vField[0].validation;
    } else {
      return "";
    }
  };

  //show and hide password

  const handleClickShowPassword = () => {
    let updatedUser = getCopy(user);
    updatedUser.showPassword = !updatedUser.showPassword;
    setUser(updatedUser);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      {loadingApi ? <LoadingAnimation /> : null}
      <div className="mb-5">
        <div className="row sideDiv">
          <div className="col-md-3" />
          <div className="login-page col-md-9" />
        </div>
        <div>
          <div
            className={
              "login-header d-flex justify-content-between align-items-center"
            }
          >
            <div>
              <img className="memonlogo-img" src={companyLogo} alt={""} />
            </div>
            <div className="font-bold font-16">
              <Link to={"/about"} className="links">
                {"About"}
              </Link>
              {" | "}
              <Link to={"/contact"} className="links">
                {"Contact"}
              </Link>
            </div>
          </div>

          <div>
            <div className="create-panel">
              <Link to={"/register"} className="createnew">
                <FontAwesomeIcon
                  icon={solid("plus-circle")}
                  size={"2x"}
                  color={"#c4be1b"}
                />
                <div className="m-2 createnew font-16 font-regular">
                  <span>Create Memon ID</span>
                </div>
              </Link>
            </div>

            <div className="login-panel">
              <div>
                <div className="m-3">
                  <div className="py-1 d-flex">
                    <MTextField
                      type="text"
                      id="inputUserId"
                      key="userCode"
                      placeholder="Memon ID"
                      maxLength="12"
                      size="12"
                      required={true}
                      error={!isFieldEmpty(getFieldErrorText("userCode"))}
                      helperText={getFieldErrorText("userCode")}
                      onChange={(event) => {
                        let updatedUser = getCopy(user);
                        updatedUser.userCode = event.target.value;
                        setUser(updatedUser);
                      }}
                    />
                  </div>
                  <div className="py-1">
                    <MPasswordField
                      type={user.showPassword ? "text" : "password"}
                      id="inputPassword"
                      className="form-control"
                      key="password"
                      placeholder="Password"
                      required={true}
                      onClickShowPassword={handleClickShowPassword}
                      onClickMouseDownPassword={handleMouseDownPassword}
                      showPassword={user.showPassword}
                      error={!isFieldEmpty(getFieldErrorText("password"))}
                      helperText={getFieldErrorText("password")}
                      onKeyDown={(event) => {
                        if (event.keyCode === 13) {
                          onSubmit();
                        }
                      }}
                      onChange={(event) => {
                        let updatedUser = getCopy(user);
                        updatedUser.password = event.target.value;
                        setUser(updatedUser);
                      }}
                    />
                  </div>

                  <div className="py-1 px-5 pt-2s d-flex justify-content-center">
                    <button
                      className="btn btn-lg btn-block custom-button"
                      disabled={false}
                      onClick={() => {
                        onSubmit();
                      }}
                    >
                      Sign in
                    </button>
                  </div>
                  <div className="d-flex justify-content-center m-3">
                    <div>
                      <Link
                        to={"/forgotpassword"}
                        className="forgot-password font-medium font-14"
                      >
                        Forgot Password?
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="info font-medium">
          <div className="px-4">
            <p className="contact"> About Us </p>
            <p className="">
              MemonID.com is an independent entity which came into existence
              with the sole purpose of working as An agency helping community
              organizations taking better decisions in their charitable
            </p>
            <p className="">
              & social activities by providing accurate information of community
              as a whole and if needed individual’s information.
            </p>
            <p className="">
              {" "}
              As Bohra, Khoja & Jain community, we don’t have a census of our
              community or unique identity allotted to our members who in many
              cases help us track the progress of individual after various
              social benefits and help passed on to them.
            </p>
            <p className="">
              <b>www.memonid.com shall serve as:</b>
              <br />
            </p>
            <div>
              {" "}
              - A digital platform to connect the entire memon community.
            </div>
            <div>
              - A connection platform for all the members to seek help or
              contribute to the community.
            </div>
            <div>
              - An exclusive search platform for the memon community wherein you
              can find and access all the community related information.
            </div>
            <br />
            <br />
          </div>
        </div>

        <div className="mentors" onClick={() => console.log("asd")}>
          <div className="mentor-parent-div col-md-6 col-sm-12">
            <h4 className="h4 brand-text-color font-medium">Mentored By</h4>
            <img
              className="mentor"
              src={require("../../assets/home-mid-1.png")}
              alt={""}
            />
            <div className="d-flex align-items-center text-center" />
            <br />
            <Link to={"/suhailkhandwani"} className={"link-blue"}>
              <strong>Mr. Suhail Khandwani</strong>
            </Link>
            <p>Businessman, Philanthropist & Social Entrepreneur.</p>
          </div>

          <div className="mentor-parent-div col-md-6 col-sm-12">
            <h4 className="h4 brand-text-color font-medium">
              Conceptualization & Executed By
            </h4>
            <img
              className="mentor"
              src={require("../../assets/home-mid-2.png")}
              alt="mentor"
            />
            <div className="d-flex align-items-center" />
            <br />
            <Link to={"/rubaidrasheedalibhojani"} className="link-blue">
              <strong>Mr. Rubaid Rasheed (Ali) Bhojani</strong>
            </Link>
            <p>Social Entrepreneur</p>
          </div>
        </div>
        <div className="mt-3">
          <div className="mentor-parent-div text-dark font-30 mb-1">
            <strong className="brand-text-color font-regular">Sponsors</strong>
          </div>
          <div>
            {sponsors.map((sponsor, index) => (
              <span className="mentor-parent-div" key={index}>
                <img
                  className={
                    sponsor.isCircular
                      ? "mentor col-md-1 col-sm-2 col-3"
                      : "mentor1 col-md-1 col-sm-2 col-3"
                  }
                  src={sponsor.imagePath}
                  alt={sponsor.imageUrl}
                  onClick={() =>
                    sponsor.imageUrl
                      ? openInNewTab(sponsor.imageUrl)
                      : console.log()
                  }
                />
              </span>
            ))}
          </div>
        </div>
      </div>
      <AppFooter />
    </>
  );
}
